import { API_ENPOINTS } from '../../constants/api';
import { get, put, post } from '../../utils/requests';
import { deserializeLayouts, serializeLayouts } from './serializers';

const LAYOUT_API = API_ENPOINTS.LayoutTemplate;

export const fetchAllLayouts = () => {
  const endpoint = LAYOUT_API;
  return get(endpoint);
};

export const fetchAllVisibleLayouts = () => {
  const endpoint = `${LAYOUT_API}/visible`;
  return get(endpoint);
};

export const fetchLayout = (id) => {
  const endpoint = `${LAYOUT_API}/${id}`;
  return get(endpoint).then(deserializeLayouts);
};

export const updateLayout = (id, layout) => {
  const endpoint = `${LAYOUT_API}/${id}`;
  return put(endpoint, serializeLayouts(layout));
};

export const postLayout = (layout) => {
  const endpoint = `${LAYOUT_API}`;
  return post(endpoint, serializeLayouts(layout));
};



// WEBPACK FOOTER //
// src/actions/layout/apiRequests.js